module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup",
    on: {
      "click": function($event) {
        _vm.trigger = false
      }
    }
  }, [_c('div', {
    staticClass: "popup-trigger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleTriggerClick($event)
      }
    }
  }, [(_vm.iconClass) ? _c('i', {
    staticClass: "popup-icon-left",
    class: _vm.iconClass
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "popup-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    staticClass: "popup-icon-right tofu-icon icon-triangle-down",
    class: {
      reverse: _vm.direction === 'north' ? !_vm.trigger : _vm.trigger
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "popup"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.trigger),
      expression: "trigger"
    }],
    staticClass: "popup-menu",
    class: _vm.direction,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.autoClose && (_vm.trigger = false)
      }
    }
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-492c0831!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/src/popup.vue
// module id = 648
// module chunks = 0